import { render } from "./DescriptionView.vue?vue&type=template&id=1d25cc6d"
import script from "./DescriptionView.vue?vue&type=script&lang=js"
export * from "./DescriptionView.vue?vue&type=script&lang=js"

import "./DescriptionView.vue?vue&type=style&index=0&id=1d25cc6d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__